<template>
  <!--询盘服务-->
  <div class="ab-product">
    <div class="ab-product-header flex-row">
      <div class="ab-banner-header flex-col">
        <MainNav />
        <div class="ab-banner-info">
          <img
            class="banner_png"
            src="@/assets/product/banner1.png"
            alt="外贸极客您全球营销的超级助手！在外贸竞赛中脱颖而出，从未如此简单！外贸极客，AI驱动的一站式智能量化营销解决方案，专业为外贸B2B出口企业打造。无论您是希望快速精准获客，还是提升成交转化，亦或是降低运营成本，外贸极客都能轻松满足。"
          />
          <div class="bannerLabelContainer">
            <div class="bannerLabel warp">
              <h1 class="banner_title" data-aos="fade-down" data-aos-delay="50">
                <span class="color_title">外贸极客 </span>
                您全球营销的超级助手！
              </h1>

              <p class="banner_desc" data-aos="fade-down" data-aos-delay="100">
                在外贸竞赛中脱颖而出，从未如此简单！外贸极客，AI驱动的一站式智能量化营销解决方案，专业为外贸B2B出口企业打造。无论您是希望快速精准获客，还是提升成交转化，亦或是降低运营成本，外贸极客都能轻松满足。
              </p>
              <div class="banner_tag" data-aos="fade-down" data-aos-delay="100">
                AI自动找客户<span> / </span>AI自动建站SEO优化<span> / </span
                >AI自动社媒运营<span> / </span>AI自动开发客户
              </div>
              <div class="banner_btn" data-aos="fade-down" data-aos-delay="150">
                <div
                  class="banner_btn_item banner_btn_item_primary"
                  @click="showModal"
                >
                  立即体验
                </div>

                <div class="banner_btn_item" @click="showModal">
                  了解更多
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <ProductTab :dataList="dataList" />
    <Footer />
    <inquiry-modal-vue
      :visible="visible"
      @cancel="handleCancel"
    ></inquiry-modal-vue>
  </div>
</template>

<script>
import MainNav from "@/components/MainNav.vue";
import Abbutton from "@/components/Abbutton.vue";
// import InquiryModalVue from "@/components/InquiryModal.vue";
import inquiryModalVue from "@/components/InquiryModal2.vue";
import Footer from "./components/Footer.vue";
import ProductTab from "./components/ProductTab.vue";
import metaInfo from "@/metaInfo";
import icon1 from "@/assets/home/截图/1.png";
import icon5 from "@/assets/home/截图/5.png";
import icon4 from "@/assets/home/截图/4.png";
import icon3 from "@/assets/home/截图/3.png";
import icon2 from "@/assets/home/截图/2.png";
import { usePageTracker } from "@/utils/pageTracker";

export default {
  metaInfo: metaInfo["igeek"],
  components: {
    MainNav,
    Abbutton,
    Footer,
    ProductTab,
    inquiryModalVue,
  },
  data() {
    return {
      visible: false,
      dataList: [
        {
          img: icon1,
          anchorId: "anchor1",
          className: "whiteBg",
          button: true,
          title: "营销管理",
          desc: "为您提供高效的营销管理方案。",
          alt:
            "包括营销团队管理、角色权限、公司文件、消息提醒、智能助手和内容生成功能，通过高效、多语言支持的全方位营销管理方案满足企业各种需求。",
          subList: [
            {
              title: "基础功能",
              desc:
                "涵盖营销团队管理、角色权限、公司文件和消息提醒，确保业务顺利进行。",
            },
            {
              title: "智能助手",
              desc:
                "提供高效的翻译、数据学习、资料查询和智能绘图设计，满足各种营销需求。",
            },
            {
              title: "内容生成",
              desc:
                "高效生成多语言营销素材，包括品牌信息、产品详情、动态文章及更多，全方位提升企业品牌力。",
            },
            {
              title: "经验策略",
              desc: "快速获取市场动态，制定精准策略。业务需求。",
            },
          ],
          tags: [],
        },
        {
          img: icon2,
          title: "推广引流",
          className: "reverse",
          button: true,
          anchorId: "anchor2",
          desc: "为企业提供一站式的智能营销服务。",
          alt:
            "智能建站、邮件营销、社媒营销、智能推广和智能客服功能，通过高效、精准、经济的一站式服务实现业务增长和品牌提升。",
          subList: [
            {
              title: "智能建站",
              desc:
                "无需专业技术背景即可一键生成高质量独立站，并通过智能SEO优化让您在搜索引擎结果中脱颖而出。",
            },
            {
              title: "邮件营销",
              desc:
                "通过营销智能体实现邮件智能营销，涵盖客户关系管理、产品推广、潜在客户培育、内容营销、客户反馈、品牌形象建设、客户服务提升及数据分析优化。",
            },
            {
              title: "社媒营销",
              desc:
                "集成了Facebook和LinkedIn的官方授权，简化管理，提升品牌互动。",
            },
            {
              title: "智能推广",
              desc:
                "利用先进的人工智能技术，自动化执行内容营销和推广任务，显著提高效率。",
            },
            {
              title: "智能客服",
              desc:
                "提供24/7多语言支持，确保每位客户都能得到及时响应，提升满意度。<br><br>这些尖端的智能化优势，使得企业营销变得高效、精准、经济，为您的国际贸易提供坚实保障。立即体验，快速实现业务增长！",
            },
          ],
          tags: [],
        },
        {
          img: icon3,
          className: "whiteBg",
          button: true,
          anchorId: "anchor3",
          title: "快速获客",
          desc: "通过全面的智能化技术，助您轻松掌握全球商机，实现精准获客。",
          alt:
            "全面智能化技术支持，包括商机监控、客户搜索和智能推荐功能，帮助企业实现精准获客和市场先机把握。",
          subList: [
            {
              title: "商机监控",
              desc:
                "我们将全球主要社交媒体整合到系统中，通过先进的商机监控功能，实时发现和捕捉隐藏的、高价值商机，让您抢占市场先机。",
            },
            {
              title: "客户搜索",
              desc:
                "提供丰富的<strong>海关数据、全球买家信息</strong>和<strong>联系人邮箱</strong>，让您快速找到潜在客户，深入背景调查，赢在每一步。",
            },
            {
              title: "智能推荐",
              desc:
                "每天自动匹配全球潜在客户，精准的查询工具，如<strong>Google地图、Facebook、LinkedIn</strong>等，助您高效定位目标客户，迅速将结果添加至客户库，带来便捷和显著的获客效率提升。",
            },
          ],
          tags: [],
        },
        {
          img: icon4,
          title: "客户管理",
          className: "reverse",
          button: true,
          anchorId: "anchor4",
          desc:
            "在当今竞争激烈的全球市场中，精细化客户管理是成功的关键。通过高度智能化和自动化，使客户管理变得简单高效。",
          alt:
            "高度智能化的客户管理系统，包括线索培育、商机管理、售后服务和通讯工具，通过AI自动化提升客户管理效率，助力企业在竞争激烈的全球市场中取得成功。",
          subList: [
            {
              title: "线索培育",
              desc:
                "从客户筛选分配到线索管理培育，系统利用智能算法和自定义标签精准分配潜在客户，确保资源的利用。",
            },
            {
              title: "商机管理",
              desc: "智能工具提供全面的商机跟踪和分析，优化策略提升转化率。",
            },
            {
              title: "售后服务",
              desc: "系统快速响应客户需求，提高满意度和忠诚度。",
            },
            {
              title: "通讯工具",
              desc:
                "邮件、全球电话、WhatsApp 保证与客户的紧密联系，实现高效沟通和快速响应。<br><br>整个过程中，AI智能化管理贯穿始终，自动执行客户筛选、分配和跟进，让您的营销团队专注于有潜力的客户，提升整体业绩。",
            },
          ],
          tags: [],
        },
        {
          img: icon5,
          className: "whiteBg",
          button: true,
          anchorId: "anchor5",
          title: "服务支持",
          desc:
            "致力于为用户提供全面、贴心且可靠的服务支持，确保用户在使用外贸极客时能够顺畅、简单、高效。",
          alt:
            "全面详尽的服务支持，包括基础文档和培训、辅助实施和支持、专业人工代运营等，确保用户顺畅高效使用外贸极客，助力业务快速腾飞。",
          subList: [
            {
              title: "基础文档和培训",
              desc:
                "我们提供详细的系统操作指南，包括文字文档和视频教程，涵盖从基础设置到高级操作的所有内容，以帮助用户快速上手并深度理解系统功能。",
            },
            {
              title: "辅助实施和支持",
              desc:
                "实施服务涵盖系统初始化配置、资料素材处理、网站建站和账号配置等，全程技术团队实时在线答疑，减少操作难题和工作中断。",
            },
            {
              title: "专业人工代运营",
              desc:
                "我们的专业人工服务团队可为客户提供代运营服务，包括营销管理、品牌推广引流和数据获客等，确保系统得到充分利用，帮助客户实现业务增长、提升市场竞争力。<br><br>无论您是初次接触还是已有一定经验，我们都能为您提供贴心、可靠的服务支持，助力您的外贸业务腾飞。",
            },
          ],
          tags: [],
        },
      ],
    };
  },
  methods: {
    showModal() {
      usePageTracker().openInNewTab(
        "https://crm.cnabke.com/#/passport/register"
      );
      // window.open("https://crm.cnabke.com/#/passport/register", "_blank");
      this.visible = true;
    },

    handleCancel() {
      this.visible = false;
    },
  },
};
</script>

<style lang="sass">
.ab-product .ab-question .q-list .q-item .q-block{
height:8rem
}
.ab-product-header {
  height:600px;
  // background: url('~@/assets/images/外贸极客_banner.png') 100% no-repeat;
  width: 100%;
  background-size:cover;
  .ab-btn {
    font-weight: 800;
font-size: 26px;
  }
}

.ab-product .ab-banner-header {
  width: 100%;
  height: 100%;

  .ab-banner-info{
    // padding-top:74px;
    padding-left:0px !important;
      position: relative;
      .banner_png {
        width: 100%;
        }
        .bannerLabelContainer {
                position: absolute;
                width: 100%;
    top: 0px;
                }
          .bannerLabel {
            font-family: "Alibaba-PuHuiTi-R";
            padding: 100px 0 0 100px;
            .banner_title {
              font-family: AlibabaPuHuiTiM;
                      font-weight: 500;
font-size: 44px;
line-height: 38px;
color: #333646;
margin-bottom: 26px;
.color_title {
  background-image: linear-gradient(0.7112178312210219deg, #333646 0%, #256FF2 5%, #3986F6 43%, #5DC0F5 100%);
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  }
              }
              .banner_desc {
                font-size: 18px;
color: #303D58;
line-height: 42px;
width: 682px;
margin-bottom: 18px;
                          }
                            .banner_tag {
                              font-size: 14px;
color: rgba(48,61,88,0.8);
span {
  color: rgba(12, 22, 105, 0.3);
  margin: 0 10px;
  }
                              }
                          .banner_btn {
                                display: flex;
                                column-gap: 16px;
                                margin-top: 50px;
                                .banner_btn_item {
                                  width: 223px;
                                  height: 55px;
                                  line-height: 55px;
                                  text-align: center;
                                  border-radius: 8px;
                                  border: 1px solid #0076FF;
                                  font-weight: 500;
                                  font-family: AlibabaPuHuiTiM;
                                  font-size: 18px;
                                  cursor: pointer;
                                  color: #0076FF;

                                  }
                                  .banner_btn_item_primary {
                                    background: #0076FF;
                                    color: #fff;
                                    }
                                }
          }




  }
}

.iserver-product-features{
  padding-top: 55px;
  .features-list{
    padding-top: 62px;
  }
}
</style>
